import { TypeCurveRiskingBase } from './base/type-curve-risking-base';

export class TypeCurveRisking extends TypeCurveRiskingBase { }